module.exports = __webpack_public_path__ + "2cf48a91bfa0da76adbda00edfd5f2d6.ico";